import { addFacetQueryString, addPreview, addVendor, getResId } from './helper';

import { RequestParams } from './new-contract/types';

const buildPdsUrlNewContract = (parameters: RequestParams): string => {
  const {
    brand,
    cid,
    facetQueryString,
    locale,
    market,
    wipAppChoice,
    previewDate,
    productsUrl,
  } = parameters;
  const inventoryGte = 1;
  const pageSize = 300;
  const vendor = 'Certona';
  const trackingid = getResId(productsUrl);
  const facetQueryStringWithPageNumber = facetQueryString?.replace(
    'pageId',
    'pageNumber'
  );

  const baseUrl = `brand=${brand}&market=${market}&cid=${cid}&locale=${locale}&pageSize=${pageSize}&inventoryGte=${inventoryGte}`;
  let completeUrl = baseUrl;
  completeUrl = addPreview(completeUrl, wipAppChoice, previewDate);
  completeUrl = addFacetQueryString(
    completeUrl,
    facetQueryStringWithPageNumber
  );
  completeUrl = addVendor(completeUrl, vendor, trackingid);

  return `${productsUrl}?${new URLSearchParams(completeUrl)}`;
};

export default buildPdsUrlNewContract;
